module.exports = __webpack_public_path__ + "static/media/type-line.24ce8e97.svg";